module.exports = __webpack_public_path__ + "img/pic03@2x.8d3f2297.png";